import { combineReducers } from 'redux';
import { CartItemDto } from '../../dto/auth.dto';
export const Set_Cart = 'SETCART';
export const ActionsCartItem = {
    setCartItem(items: Array<CartItemDto>) {
        return { type: Set_Cart, items: items };
    }
}
  
const CartItems = (state: Array<CartItemDto> = [], action: any) => {

    switch (action.type) {
        case Set_Cart:
            state = action.items;
            return state
        default:
            return state
    }
}
export const getCartItems = (state: any) => {
    return state.CartItems;
}
export default combineReducers({
    CartItems
});
